export const UPDATE = 'UPDATE'
// export const SUBMIT = 'SUBMIT'
export const RESET = 'RESET'
